import { useQuery } from "@apollo/client";
import { ICardStatusResponse } from "./card-status.interface";
import { CARD_STATUS } from "./card-status.query";

export const useCardStatus = () => {
  const { loading, data } = useQuery<{ getHavePaymentMethod: ICardStatusResponse }>(CARD_STATUS, {
    fetchPolicy: "network-only",
  });

  return {
    loading,
    paymentMethod: data?.getHavePaymentMethod,
  };
};
